import { StorageKey } from '../enum/StorageKey';
import { ApplicationConfig } from '../interface/response/ApplicationConfig';

export const getItemFromLocalStorage = (key: string) => localStorage.getItem(key);

export const setItemToLocalStorage = (key: string, data: string) => {
  localStorage.setItem(key, data);
};

export const clearLocalStorage = () => {
  localStorage.clear();
};

export const removeItemFromLocalStorage = (key: string) => {
  localStorage.removeItem(key);
};

export const clearLocalStorageItems = (storageKeys: StorageKey[]) => {
  storageKeys.map((storageKey) => localStorage.removeItem(storageKey));
};

export const clearLocalStorageExcept = (keysToKeep?: string[]) => {
  Object.keys(localStorage).forEach((key) => {
    const shouldKeepTableConfig = key.endsWith(`_${StorageKey.TABLE_CONFIG}`);

    const shouldKeep = keysToKeep?.includes(key) || shouldKeepTableConfig;

    if (!shouldKeep) {
      localStorage.removeItem(key);
    }
  });
};
export const getConfigFromLocalStorage = (): ApplicationConfig | null => {
  const config = getItemFromLocalStorage(StorageKey.CONFIG);
  return config ? JSON.parse(`${config}`) : null;
};

export const setConfigToLocalStorage = (config: ApplicationConfig | null) => {
  if (config) {
    setItemToLocalStorage(StorageKey.CONFIG, JSON.stringify(config));
  }
};
